<template>


  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：封坛管理-封坛详情
  -->
  <div class="user pb50" >
    <div class="product-content">
      <!--售后单信息-->
      <div class="common-form">申请封坛信息</div>
      <div class="refund-detail-content">
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">商品名称</span>
              {{detail.product_name}}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">用户</span>
              {{detail.nickName}}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">数量</span>
              {{detail.number}}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">处理状态：</span>
              {{detail.feng_type}}
            </div>
          </el-col>

        </el-row>
      </div>
    </div>

    <!-- 用户收货地址 -->
    <div >
      <div class="common-form mt16">用户收货地址</div>
      <el-row>
        <el-col :span="5">
          <div class="pb16">
            <span class="gray9">收货人：</span>
            {{address1.name ? address1.name: ''}}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="pb16">
            <span class="gray9">收货电话：</span>
            {{address1.phone}}
          </div>
        </el-col>
        <el-col :span="14">
          <div class="pb16">
            <span class="gray9">收货地址：</span>
            {{address1.region.province}}{{address1.region.city}}{{address1.region.region}}{{address1.detail}}
          </div>
        </el-col>
      </el-row>
    </div>
    <!--发货信息-->
    <div  v-auth="'/order/order/delivery'" >
      <div v-if="detail.type == 1" >
        <!-- 去发货 -->
        <div class="common-form mt16">去发货</div>
        <el-form size="small" ref="form" :model="form" label-width="100px">
          <el-form-item label="物流公司">
            <el-select v-model="form.express_id" placeholder="请选择快递公司">
              <el-option :label="item.express_name" v-for="(item, index) in expressList" :key="index" :value="item.express_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物流单号">
            <el-input v-model="form.express_no" class="max-w460"></el-input>
          </el-form-item>
        </el-form>

      </div>
      <!--回寄地址-->
      <div v-if="detail.type == 1">
        <div class="common-form mt16">设置回寄地址</div>
           <span class="gray9">回寄地址：</span>
          <el-select v-model="address_id" placeholder="请选择地址">
            <el-option v-for="(item, index) in address" :key="index" :label="item.detail" :value="item.address_id"></el-option>
          </el-select>

      </div>

        <div class="common-form mt16"  v-if="detail.type >=2 ">发货信息</div>
        <div class="table-wrap" v-if="detail.type >= 2">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">物流公司：</span>
                {{detail.express? detail.express.express_name:detail.express_company }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">物流单号：</span>
                {{ detail.express_no }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">发货时间：</span>

                {{ detail.send_time }}
              </div>
            </el-col>
          </el-row>
        </div>

      <div class="common-form mt16"  v-if="detail.type >=2 ">回寄地址</div>
      <div class="table-wrap" v-if="detail.type >= 2">
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">收货人：</span>
              {{ returnAddress.name ? returnAddress.name: '' }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">手机号：</span>
              {{ returnAddress.phone? returnAddress.phone:''}}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">详细地址：</span>
              {{returnAddress.detail? returnAddress.detail:'' }}
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 用户发货信息 -->
      <div  v-if="detail.type >=3">
        <div class="common-form mt16">用户发货信息</div>
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">订单号：</span>
              {{detail.express_no_1}}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">物流公司：</span>
              {{detail.express_id_1}}
            </div>
          </el-col>
<!--          <el-col :span="14">-->
<!--            <div class="pb16">-->
<!--              <span class="gray9">收货地址：</span>-->
<!--              {{address1.region.province}}{{address1.region.city}}{{address1.region.region}}{{address1.detail}}-->
<!--            </div>-->
<!--          </el-col>-->
        </el-row>
      </div>

    </div>
<!--上传封坛条-->
    <el-form v-if="detail.type >=3">
    <el-form-item label="商品图片：" :rules="[{ required: true, message: '请上传商品图片' }]" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.model.image">
          <transition-group>
            <div class="item"  v-for="(item,index) in form.model.image" :key="item.file_id">
              <img v-img-url="item.file_path" />
              <a href="javascript:void(0);" v-if="detail.type==3" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" v-if="detail.type==3" @click="openProductUpload"><i class="el-icon-plus"></i></div>
      </div>
    </el-form-item>
    <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :config="{ total: 3 }" @returnImgs="returnImgsFunc" multiple="true"></Upload>
    </el-form>


    <div class="common-button-wrapper"  >
      <el-button size="small" type="info" @click="cancelFunc">取消 / 返回上一页</el-button>
      <el-button v-if="detail.type == 1" size="small" type="primary" @click="onSubmit(detail.fengtan_id)">确认寄送封坛条</el-button>
      <el-button v-if="detail.type ==3" size="small" type="primary" @click="onSubmit1(detail.fengtan_id)">上传图片封坛</el-button>
    </div>
  </div>



</template>
<script>
  import FengtanApi from '@/api/fengtan.js';
  import Upload from '@/components/file/Upload';
  import draggable from 'vuedraggable';
  export default {
    components:{
      Upload,
      draggable,
    },
    data() {
      return {
        // tableData: {},
        // /*退货详情*/
        detail: {
          image:[],
          delivery_type: [],
          user: {},
          address: [],
          product: [],
          order_status: [],
          extract: [],
          extract_store: [],
          express: [],
          delivery_status: [],
          extractClerk: []
        },
        // /*订单详情*/
        //
        // /*退货地址列表*/
        address: {},
        address1: {
          region:{},
        },
        form: {
          model:{
            image:[],
          },

          // is_agree: 10,

          // refuse_desc: '',
          // refund_money: 0
        },
        //退货地址id
        address_id: '',
        //退货地址详情
        returnAddress: [],
        /*快递公司列表*/
        expressList: [],
        shopClerkList: [],
        express_id:null,

        dialogImageUrl: '',
        dialogVisible: false,
        disabled: false,
        /*是否打开图片选择*/
        isupload:false,
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
    /*上传封坛条图片*/
      /*选择图片*/
      openProductUpload(){
        this.isupload=true;
      },
      /*关闭选择图片*/
      returnImgsFunc(e){
        if (e != null) {
          let imgs = this.form.model.image.concat(e);
          this.$set(this.form.model, 'image', imgs);
        }
        this.isupload = false;
      },
      /*获取列表*/
      //
      getData() {
        let self = this;
        let fengtan_id = this.$route.query.fengtan_id;
        FengtanApi.fengDetail(
          {
            fengtan_id: fengtan_id
          },
          true
        )
          .then(res => {
            self.detail = res.data.detail;
            // self.order = res.data.order;
            self.address = res.data.address;
            self.address_id = res.data.address.address_id;
            self.address1 = res.data.address1;
            self.expressList = res.data.expressList;
            self.form.model.image = res.data.imageData;
            self.returnAddress = res.data.returnAddress;
            self.loading = false;
          })
          .catch(error => {});
      },


      // /*寄送封坛条*/
      onSubmit(e) {
        let self = this;
        let param = self.form;
        let fengtan_id = e;
        let address_id = self.address_id;
        // console.log(param);
        // console.log(address_id);return;
        if (param.express_id == null) {
          this.$message.error('请选择物流公司');
          return;
        }
        if (param.express_no == '') {
          this.$message.error('请填写物流单号');
          return;
        }
        if (address_id == '') {
          this.$message.error('请选择你的回寄地址');
          return;
        }

        FengtanApi.ArticleFengTan(
          {
            param: param,
            fengtan_id:fengtan_id,
            address_id:address_id,

          },
          true
        )
          .then(res => {
            self.$message({
              message: '恭喜你，发货成功',
              type: 'success'
            });
            // this.$router.push({
            //   path: '/plus/feng/feng/detail',
            //   query: {
            //     fengtan_id: fengtan_id
            //   }
            // });
          })
          .catch(error => {});

      },
      /*删除商品图片*/
      deleteImg(index) {
        this.form.model.image.splice(index, 1);
      },


      // /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
      //封坛
      onSubmit1(e){
        let self = this;
        let imgs = self.form.model.image;
        let fengtan_id = e;
        FengtanApi.FengTan(
          {
            fengtan_id: fengtan_id,
            imgs:imgs,
          },
          true
        )
          .then(res => {
            self.loading = false;
            self.$message({
              message: '恭喜你， 上传封坛条成功',
              type: 'success'
            });
            this.$router.push({
              path: '/plus/feng/feng/detail',
            });
          })
          .catch(error => {});

      }
    }
  };
</script>
<style>
  .common-button-wrapper{
    /*position: absolute;*/
    /*white-space: nowrap;*/
    /*line-height: 1;*/
    /*text-align: center;*/
    /*box-sizing: border-box;*/
    /*transition: .1s;*/
    /*font-weight: 500;*/
    /*margin-bottom: 10px;*/
    /*padding-top: 200px;*/
  }
  .apply-reason {
    padding: 16px;
    background: #fff4f4;
    border: 1px solid #f6e6e6;
  }
  .apply-reason-box .pic {
    width: 100px;
    height: 100px;
    margin-right: 4px;
    border: 1px solid #d1d5dd;
  }
  .apply-reason-box .pic img {
    width: 98px;
    height: 98px;
    object-fit: contain;
  }
  .draggable-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
  }
  .draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }
  .draggable-list .item:hover .delete-btn {
    display: block;
  }
  .draggable-list .wrapper > span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }
  .draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/feng/feng/detail.vue